var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['tw:bg-gray-200 tw:rounded tw:animate-pulse', _vm.height, _vm.customClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }